import { combineReducers } from 'redux'

import meta from './meta'
import form from './form'
import submit from './submit'
import track from './track'
import maintenanceMessages from './maintenance-messages'

export default combineReducers({
  meta,
  form,
  submit,
  track,
  maintenanceMessages
})
